import * as icons from './icons';
import strings from './strings';

export default class Resources {
  static strings = strings;

  static icons = icons;
}
